
import { useState, useMemo, useEffect, useCallback, useContext } from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom';
import { sortRows, filterRows, paginateRows } from '../helpers'
import Pagination from '../Pagination'
import CompanyLogo from '../CompanyLogo';
import SortIcon from 'mdi-react/SortIcon'
import SortAscendingIcon from 'mdi-react/SortAscendingIcon'
import SortDescendingIcon from 'mdi-react/SortDescendingIcon'
import '../TableView.css'
import { routeNames } from '../../routeSegments';
import { getPEGlobalSearchCompaniesApi } from '../../Config/config'
import RandomLogo from '../RandomLogo';
import OverflowToolTip from '../shared/OverflowToolTip';
import { rowsPerPageData, getMaCompaniesApi, dateRangeFilter } from '../../Config/config'
import { TableDataContext } from '../../Contexts/TableDataContext'
import axios from "axios";
import CustomNavigation from '../../Utils/CustomNavigation';
import NoDataPlaceholder from '../shared/NoDataPlaceholder';
import Loader from '../Loader';
import { UserContext } from '../../Contexts/UserContext';
import AddNotePopover from '../shared/AddNotePopover';
import Constants from '../../Constants';
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import moment from "moment";
import { useRef } from 'react';
import DeleteItemsFromGroup from '../shared/DeleteItemsFromGroup';
import { toast } from 'react-toastify';
import TwolineOverflowToolTip from '../shared/TwolineOverflowToolTip';
import NewLogo from '../NewLogo';
import LZString from "lz-string"


const Table = ({ columns, order, orderBy,sub_type_master_id}) => {

  const { rows, setRows, data, setData, isLoad, setIsLoad, setIsDataLoad, setTotalNoOfCompanies, setTableCompanyId, currentPage, setCurrentPage,setCurrentFilter, setAllDealIds, globalSearchResult, setGlobalSearchResult } = useContext(TableDataContext);
  const { refineSearchFilters: contextRefineSearchFilters,
    setRefineSearchFilters: contextSetRefineSearchFilters, monthPickerValue,groupId,resetDealsByFilter,setIsMonthPickerChanged} = useContext(PeFilterContext);
  const [filters, setFilters] = useState({})
  const [activePage, setActivePage] = useState(currentPage)
const [refineSearchFilters, setRefineSearchFilters] = useState(contextRefineSearchFilters || {})
  const [isDataReady, setIsDataReady] = useState(false)
    const [urlDates, setUrlDates] = useState(null) // Store URL dates directly

  const [sort, setSort] = useState({ order: order, orderBy: orderBy })
  const [showId, setShowId] = useState(null);
  const [showNote, setShowNote] = useState(false)
  const { getToken, logout } = useContext(UserContext);
  var location = useLocation();
  const abortRef = useRef(null)
  const[reload, setReload] = useState(false)

  /**
   * The function `findActivePage` sets the current page, renders a table, and sets a flag to indicate
   * that the page is loading.
   * @param page - The `page` parameter is used to specify the current page number. It is passed to the
   * `findActivePage` function to update the current page and perform some actions based on the updated
   * page value.
   */
  const findActivePage = (page) => {
    setCurrentPage(page)
    tableRender(page, monthPickerValue, sort.orderBy, sort.order,groupId)
    setIsLoad(true)
    // if(menu == "pe" || menu == "vc"){
    //   setActiveTabDeal('investments')
    // }
  }

  // Process all URL parameters and set all necessary data in one effect
  useEffect(() => {
    console.log("Processing URL parameters and setting up data...")

    const queryParams = new URLSearchParams(location.search)
    let processedFilters = {} // Start with an empty object for URL filters
    let extractedDates = null

    // Handle 'filters' param
    const compressed = queryParams.get("filters")
    if (compressed) {
      try {
        const decompressed = LZString.decompressFromEncodedURIComponent(compressed)
        const urlFilters = JSON.parse(decompressed)
        processedFilters = urlFilters
        console.log("Processed filters from URL:", urlFilters)
      } catch (error) {
        console.error("Error decompressing or parsing filters:", error)
      }
    }

    // Handle 'gs' param (globalSearchResult)
    const gsCompressed = queryParams.get('gs');
    if (gsCompressed) {
      try {
        const gsDecompressed = LZString.decompressFromEncodedURIComponent(gsCompressed);
        const gsData = JSON.parse(gsDecompressed);
        
        console.log('Retrieved globalSearchResult from URL:', gsData);
        if (gsData && Object.keys(gsData).length > 0) {
          // Set the data in the context
          setGlobalSearchResult(gsData);
          console.log('Set globalSearchResult in context from URL param:', gsData);
          
          // Create a globalSearch entry in refineSearchFilters to trigger the right condition
          const pathKey = location.pathname;
          const updatedFilters = {...refineSearchFilters};
          
          if (!updatedFilters[pathKey]) {
            updatedFilters[pathKey] = {};
          }
          
          updatedFilters[pathKey].globalSearch = ['1']; // Set it to have length 1
          setRefineSearchFilters(updatedFilters);
        }
      } catch (error) {
        console.error('Error decompressing or parsing globalSearchResult:', error);
      }
    }

    // Handle 'date' param - extract and store directly
    const dateParam = queryParams.get("date")
    if (dateParam) {
      console.log("Found date parameter:", dateParam)
      const [startStr, endStr] = dateParam.split(",")
      const startDate = moment(startStr, "YYYY-MM-DD")
      const endDate = moment(endStr, "YYYY-MM-DD")

      if (startDate.isValid() && endDate.isValid()) {
        // Store dates directly for API use
        extractedDates = {
          from_date: startDate.format("YYYY-MM-DD"),
          to_date: endDate.format("YYYY-MM-DD"),
        }
        console.log("Extracted dates from URL:", extractedDates)
        setUrlDates(extractedDates)
      } else {
        console.warn("Invalid date format in query params:", { startStr, endStr })
      }
    }

    // Set local and context refineSearchFilters first
    console.log("Setting refineSearchFilters:", processedFilters)
    setRefineSearchFilters(processedFilters)

    // Reset deals by filter
    resetDealsByFilter()

    // Mark data as ready for API call
    setIsDataReady(true)

    console.log("URL processing complete. Data ready for API call.", {
      extractedDates,
      processedFilters,
    })
  }, [location.search]) // Only depend on location.search

  useEffect(()=>{
    console.log("jjjhhk inv" , location?.key)
    resetDealsByFilter();
  },[location?.key])
/**
 * The function `isFromGlobalSearch` checks if there are any global search filters applied based on the
 * current location pathname.
 */
  const isFromGlobalSearch = ()=> globalSearchResult?.length === 0 ? false : true

 /* The above code is a JavaScript function called `tableRender`. It is using the `useCallback` hook to
 memoize the function and optimize performance. */
  const tableRender = useCallback((page, month, column, order,groupId) => {
    // Use URL dates if available, otherwise fall back to monthPickerValue
              let dateRange
              if (urlDates) {
                dateRange = urlDates
                console.log("Using URL dates for API call:", dateRange)
              } else if (monthPickerValue && Array.isArray(monthPickerValue) && monthPickerValue.length === 2) {
                dateRange = {
                  from_date: moment(monthPickerValue[0]).format("YYYY-MM-DD"),
                  to_date: moment(monthPickerValue[1]).format("YYYY-MM-DD"),
                }
                console.log("Using monthPickerValue for API call:", dateRange)
              } else {
                console.log("No valid dates available for API call, using default or empty.")
                // Provide a default or empty date range if none is found
                dateRange = { from_date: null, to_date: null }
              }
        
              console.log("Making API call with:", {
                page,
                dateRange,
                column,
                order,
                groupId,
                currentRefineFilters: refineSearchFilters['/re/companies/re-investments'], // Log current filters,
                
              })
              console.log(location.pathname, "location pathname",location.pathname.endsWith('/all')? location.pathname.substring(0, location.pathname.lastIndexOf('/')): location.pathname)
        
              setIsMonthPickerChanged(0)
    console.log(month, 'ma usecallback month');
    // setIsTagClosed(0)
    // setIsMonthPickerChanged(0)
    const modifiedPath = location.pathname.endsWith('/all')? location.pathname.substring(0, location.pathname.lastIndexOf('/')): location.pathname;
    axios(`${getMaCompaniesApi}`, {
      method: "POST",
      signal: abortRef.current.signal,
      data:{
        date_range: dateRange,
        "order_by": {
          "column": column,
          "direction": order
        },
        from : isFromGlobalSearch() ? 'gs' : '',
        "page": page,
        "per_page": 200,
        company_ids: isFromGlobalSearch() ? globalSearchResult?.merger_acquisition_cmp_ids?.length === 0
            ? [0] : globalSearchResult?.merger_acquisition_cmp_ids
            : refineSearchFilters[modifiedPath]?.target_company?.map(company => company.id),
          acquirer_group: refineSearchFilters[modifiedPath]?.acquirer_group?.map(opt => opt.name),
        deal_ids: isFromGlobalSearch() ? globalSearchResult?.merger_acquisition?.length === 0
          ? [0] : globalSearchResult?.merger_acquisition : [],
        "acquirer_city": refineSearchFilters[modifiedPath]?.acquirerCity?.map(city => city.id),
        "acquirer_ids":refineSearchFilters[modifiedPath]?.acquirers?.map(acq => acq.id) ,
        "acquirer_company_type": refineSearchFilters[modifiedPath]?.acquirerType?.map(type => type.id),
        "acquirer_country": refineSearchFilters[modifiedPath]?.acquirerCountries?.map(city => city.id),
        "company_group": refineSearchFilters[modifiedPath]?.group?.map(group => group.name),
        "acquirer_region": refineSearchFilters[modifiedPath]?.acquirerRegion?.map(city => city.id),
        "acquirer_state": refineSearchFilters[modifiedPath]?.acquirerState?.map(city => city.id),
        "deal_range": refineSearchFilters[modifiedPath]?.dealRange?.at(0) && {
          "from": refineSearchFilters[modifiedPath]?.dealRange[0].name,
          "to": refineSearchFilters[modifiedPath]?.dealRange[1].name
        },
        "deal_type": refineSearchFilters[modifiedPath]?.dealType?.map(type => type.id),
        "ladvisor_ids":refineSearchFilters[modifiedPath]?.ladvisors?.map(acq => acq.id)  ,
        // "operator" : refineSearchFilters[modifiedPath]?.operator,
        "tadvisor_ids":refineSearchFilters[modifiedPath]?.tadvisors?.map(acq => acq.id)  ,
        "target_city": refineSearchFilters[modifiedPath]?.city?.map(city => city.id),
        "target_company_type": refineSearchFilters[modifiedPath]?.companyType?.map(type => type.id),
        "target_country": refineSearchFilters[modifiedPath]?.countries?.map(country => country.id),
        "target_industry": refineSearchFilters[modifiedPath]?.industry?.map(value => value.id),
        "target_sector" : refineSearchFilters[modifiedPath]?.sector?.map(value => value.name),
        "target_region": refineSearchFilters[modifiedPath]?.region?.map(region => region.id),
        "target_state": refineSearchFilters[modifiedPath]?.state?.map(state => state.id),
        "valuation": refineSearchFilters[modifiedPath]?.valuations?.map(valuation => valuation.value),
        group:{  
          group_id: groupId?.myList?.map(id => id.group_id)?.toString() ?? null,
          sub_type_master_id: groupId?.myList?.length >0 ? sub_type_master_id :null   
        }
      },
      headers: {
        "Content-Type": "application/json",
        "Authorization": getToken()
      },

    })
      .then((response) => {
        if (response?.data?.message == "Success") {
          setCurrentFilter(response.config.data)
          // console.log(response,'cfs table response');       
          setTotalNoOfCompanies(response?.data?.num_companies)
          setIsLoad(false)
          setIsDataLoad(false)
          // setIsMonthPickerChanged(0)
          setRows([])
          setRows(response?.data?.companies)
          setData(response?.data)
          setTableCompanyId([])
          setTableCompanyId(response?.data?.all_companies_ids)
          setAllDealIds(response?.data?.all_deal_ids)
          console.log(response?.data, 'cfs table response');
        }
      })
      .catch((error) => {
        if (error?.response?.status == Constants.sessionTerminatedStatus 
            || error?.response?.status == Constants.InvalidTokenStatus
          ){
          logout();
        }
        console.log("API not working", error);
      });
  }, [refineSearchFilters]);


  useEffect(() => {
    const abortController = new AbortController()
    abortRef.current = abortController;
    setIsLoad(true)
    setIsDataLoad(true)
    setCurrentPage(currentPage);
    tableRender(currentPage, monthPickerValue, sort.orderBy, sort.order,groupId )
    return () => {
      abortController.abort();
    }
  }, [tableRender, monthPickerValue,groupId,reload]);

 /**
  * The addNote function toggles the visibility of a note and sets the id of the note to be shown.
  * @param id - The `id` parameter is the identifier of a note.
  */
  const addNote = (id) => {
    setShowNote(!showNote)
    setShowId(id)
  }

  const rowsPerPage = rowsPerPageData

/* The above code is using the `useMemo` hook in React to memoize the result of calling the
`filterRows` function with the `rows` and `filters` variables as arguments. This means that the
`filterRows` function will only be called again if either `rows` or `filters` change. The memoized
result is stored in the `filteredRows` constant. */
  const filteredRows = useMemo(() => filterRows(rows, filters), [rows, filters])
  // const sortedRows = useMemo(() => sortRows(filteredRows, sort), [filteredRows, sort])
  // const calculatedRows = paginateRows(sortedRows, currentPage, rowsPerPage)
  // console.log(calculatedRows, "cfs calculated")

 /**
  * The function `handleSort` is used to handle sorting of data in a table based on a given accessor
  * and order.
  * @param accessor - The `accessor` parameter is a value that represents the property or key of the
  * object that you want to sort by. It is used to identify the specific property or key that you want
  * to sort the data by.
  * @param order - The "order" parameter is used to specify the sorting order. It can have two possible
  * values: "asc" for ascending order and "desc" for descending order.
  */
const handleSort = (accessor) => {
  setCurrentPage(currentPage); // Assuming currentPage is defined elsewhere
  setRows([]);
  setIsLoad(true);
  setIsDataLoad(true);

  const isNumericColumn = ["deal_amount", "valuation"].includes(accessor);

  setSort((prevSort) => {
    const isSameColumn = prevSort.orderBy === accessor;
    const newOrder = isSameColumn
      ? prevSort.order === "desc" ? "asc" : "desc"
      : isNumericColumn ? "desc" : "asc"; // Default to 'desc' for numeric columns, 'asc' for others

    tableRender(currentPage, monthPickerValue, accessor, newOrder, groupId);

    return {
      order: newOrder,
      orderBy: accessor,
    };
  });
};
  const count = filteredRows?.length
  // const totalPages = Math.ceil(count / rowsPerPage)

  /**
   * The function `addCommasToNumber` takes a number as input and returns a string representation of
   * the number with commas added for thousands separators.
   * @param number - The `number` parameter is the number to which commas need to be added.
   * @returns The function `addCommasToNumber` returns a string representation of the input number with
   * commas added as thousands separators.
   */
  const addCommasToNumber = (number) => {
    return number?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };
  useEffect(()=>{
    console.log(location?.state?.isFromGlobalSearch, 'isFromGlobalSearch');

  },[location?.state?.isFromGlobalSearch])

  return (
    <>
      <div className="md:col-span-4 col-span-5">
        <div className="lg:col-span-4">
          <div className="scrollbar ">
            <div className={"overflow-x-auto scrollbar rounded-b-[6px] "+(rows?.length > 5 ? '':'pr-2')}>
            <table className="listPage table w-full p-1 bg-grey-50 divide-y" width="50%">
              <thead className="bg-[#EBEBEB] text-[11pt] leading-[16pt] lg:text-[13px] lg:leading-[15px] font-semibold text-[#666666]  text-left">
                  <tr>
                    {columns.map((column, i) => {
                      const sortIcon = () => {
                        if (column.accessor === sort.orderBy) {
                          if (sort.order === 'asc') {
                            return <SortDescendingIcon className="pl-2 block h-[15px]" />
                          }
                          return <SortAscendingIcon className="pl-2 block h-[15px]" />
                        } else {
                          return <SortIcon className="pl-2 block h-[15px] " />
                        }
                      }
                      return (

                        <th className={i === 0 ? "md:pl-5 md:pr-5 pl-5 pr-[16rem]" : "px-5 " + " py-2 font-sans_book_body"} key={i}>
                          <span className="flex whitespace-nowrap">
                            <OverflowToolTip component={
                              <a className='cursor-text hover:text-[#000000]'>
                                {column.accessor === "add" && groupId?.myList?.length > 0 ? "Delete" :
                                  column.accessor === "add" ? (
                                    <div className="flex flex-col text-center">
                                      <span>Create</span>
                                      <span>your list</span>
                                    </div>
                                  ) : column.accessor === "deal_amount" || column.accessor === "amount" ? (
                                    <div className="flex flex-col text-right">
                                      <span>Amount</span>
                                      <span>(US$ M)</span>
                                    </div>
                                  ) : column.label ? column.label : "--"}
                              </a>
                            } />
                            {column.accessor !== "add" && (
                              <button onClick={() => handleSort(column.accessor, sort.order)}>
                                {sortIcon()}
                              </button>
                            )}
                          </span>
                        </th>

                      )
                    })}
                  </tr>
                </thead>
                {!isLoad ?
                  count > 0 ?
                    <tbody className="text-[11pt] leading-[16pt] lg:text-[14px] lg:leading-[16px] font-sans_book_body text-[#333333] text-left">
                      {rows?.length > 0 ?
                        rows?.map((row, i) => {
                          return (
                            <tr key={i} className=" group hover:border-l-4 hover:border-l-[#BC8B20] border-l-4 border-l-[#FFFFFF]   border-b bg-white text" >
                            <td className="w-[20%] 2xl:w-[15%] leading-relaxed px-5 py-3 font-sans_book_body card-animate">
                              <div className="flex items-center">
                              <NewLogo id={row.company_id} name={row.company} />

                                <OverflowToolTip
                                  className="w-full lg:max-w-full"
                                  component={
                                    <NavLink
                                      className="flex text-start leading-[1.1rem] lg:inline lg:whitespace-normal break-words hover:text-[#BC8B20] font-medium"
                                      to={routeNames.maCompanyById(row.company_id)}
                                    >
                                      {row?.company ? (
                                        <>
                                          {row?.company}
                                          {row?.agghide && (
                                            <span className="rounded-md bg-[#f3e8ff] px-2 py-[3px] ml-2 text-xs font-sans_book_body text-[#3939ab]">
                                              {row?.agghide}
                                            </span>
                                          )}
                                          {row?.asset && (
                                            <span className="rounded-md bg-[#f3e8ff] px-2 py-[3px] ml-2 text-xs font-sans_book_body text-[#3939ab]">
                                              {row?.asset}
                                            </span>
                                          )}
                                        </>
                                      ) : (
                                        "--"
                                      )}
                                    </NavLink>
                                  }
                                />
                              </div>
                            </td>
                            <td className="w-[19%] py-3 px-5 font-sans_book_body whitespace-normal break-words">
                              <TwolineOverflowToolTip
                                className="w-[10rem] line-clamp-2 leading-relaxed"
                                component={<span className="whitespace-normal break-words">{row.sector ? row.sector : "--"}</span>}
                              />
                            </td>
                            <td className="w-[12%] py-3 px-5 font-sans_book_body whitespace-normal break-words">
                              <TwolineOverflowToolTip
                                className="w-[10rem] line-clamp-2 leading-relaxed"
                                component={
                                  <NavLink
                                    className="flex text-start lg:inline leading-[1.1rem] hover:text-[#BC8B20] font-medium whitespace-normal break-words"
                                    state={{ fromPath: location.pathname }}
                                    to={routeNames.maAcquiresById(row.acquirer_id)}
                                  >
                                    {row.acquirer ? row.acquirer : "--"}
                                  </NavLink>
                                }
                              />
                            </td>
                              <td className="w-[6%] py-3 px-5 font-sans_book_body whitespace-nowrap" >
                                {row.deal_date ? <Link className='hover:text-[#BC8B20] font-medium'
                                  to={{
                                    pathname: routeNames.maCompanyDealById(row?.company_id, row?.deal_id)
                                  }}>
                                  {row.deal_date}
                                </Link> : "--"}
                              </td>
                              <td className=" w-[2%]  pr-[3rem] lg:pr-[3rem] py-3  font-sans_book_body text-right"><p>{row.deal_amount != 0.00 ? addCommasToNumber(row.deal_amount) : "--"}</p></td>
                              <td className={groupId?.myList?.length >0 ?"w-[1%] px-5 py-3  font-sans_book_body  ":"w-[1%]  py-3  font-sans_book_body " }>
                              {groupId?.myList?.length >0 ? 
                                 <DeleteItemsFromGroup id={row.company_id} group_id={row?.grp_lt_item_id} type_id={Constants.moduleIds.companiesId} setReload={setReload}/>
                                 :(<div className="flex justify-center">
                                  <AddNotePopover className="" key={row.company_id} companyId={row.company_id} companyName={row.company} type_id={Constants.moduleIds.companiesId} sub_type_master_id={sub_type_master_id}/>
                                 </div>) 

                        }</td>
                            </tr>
                          )
                        })
                        : <center><div className="h-[4rem] text-[12pt] lg:text-[15px] text-[15px] text-[#333333] relative mt-[3rem] left-[30rem]">No data found</div></center>
                      }
                    </tbody>
                    : <></>
                  : <></>
                }
              </table>

              {!isLoad ?
                count > 0 ?
                  <></>
                  : <div className='pr-2'>
                  <div className='w-full h-[17rem] bg-white flex items-center justify-center fixed md:relative'>
                    <NoDataPlaceholder />
                  </div>
                </div>
              :
              <div className='w-full h-[17rem] bg-white flex items-center justify-center absolute md:relative'>
                <Loader />
              </div>
              }
            </div>
          </div>
        </div>
      </div>


     
    </>
  )
}

export default Table
